import { useMemo } from "react";

export const useCardSize = (size: string, S: { [key: string]: string }) => {
    const cardSizeClass = useMemo(() => {
        switch (size) {
            case "CARD_SIZE_EXTRA_SMALL":
                return S.cardSizeExtraSmall;
            case "CARD_SIZE_MEDIUM":
                return S.cardSizeMedium;
            case "CARD_SIZE_LARGE":
                return S.cardSizeLarge;
            case "CARD_SIZE_EXTRA_LARGE":
                return S.cardSizeExtraLarge;
        }
    }, [size, S]);

    return {
        cardSizeClass,
    };
};
